import Config from '../config';
import { AxiosInstance } from '../helpers/AxiosInstance';

const getImprovedMessage = (data:
    {
        message: string,
        improve: boolean,
        length: string,
        tone: string,
        translate: string,
        channel: number
    }
) => {
    return AxiosInstance.post(`${Config.FALKON_AI_URL}/falkon-chat-ai/api/refine-message`, data);
};//get improved message using ai service

const getChatSummaryandSentiment = (data:
    {
        text: string,
        channel: number,
        contact: string
    }
) => {
    return AxiosInstance.post(`${Config.FALKON_AI_URL}/falkon-chat-ai/api/chat-summary-with-sentiment`, data);
};//get chat summary and customer review

const getLastGeneratedChatSummaryandSentimentByPhoneNumber = (PhoneNumber: string) => {
    return AxiosInstance.get(`${Config.FALKON_AI_URL}/falkon-chat-ai/api/get-summary/${PhoneNumber}`);
};//get chat summary and customer review

const getReplySuggestions = (data:
    {
        organization_id: string,
        message: string,
        text: string,
        image_urls: string[]
    }) => {
    return AxiosInstance.post(`${Config.FALKON_AI_URL}/falkon-chat-ai/api/suggest-reply-array-with-context-and-vision`, data);
};//get reply suggestions based on the feed data

const UploadFilesToAi = (data) => {

    const config = {
        headers: {
            "Content-Type": "multipart/form-data"
        }
    };

    return AxiosInstance.post(`${Config.FALKON_AI_URL}/falkon-chat-ai/api/uploadFile`, data);
};//upload files to falkon ai

const TrainUploadFilesToAi = (data:
    {
        organization_id: string,
    }) => {
    return AxiosInstance.post(`${Config.FALKON_AI_URL}/falkon-chat-ai/api/queue-pdf`, data);
};//feed the falkon ai with the uploaded files

const TrainFailedFileToAi = (data:
    {
        organization_id: string,
        file_name: string,
    }) => {
    return AxiosInstance.post(`${Config.FALKON_AI_URL}/falkon-chat-ai/api/queue-one-pdf`, data);
};//feed the failed file to falkon ai again

const DeleteTrainedFileFromAi = (data:
    {
        organization_id: string,
        file_name: string,
    }) => {
    return AxiosInstance.post(`${Config.FALKON_AI_URL}/falkon-chat-ai/api/deleteFile`, data);
};//delete the file data from falkon ai

const getAllFiles = (OrganizationID: string) => {
    return AxiosInstance.get(`${Config.FALKON_AI_URL}/falkon-chat-ai/api/listfiles?organization_id=${OrganizationID}`);
};//get all the files uploaded for falkon ai

const TrainUrlsToAi = (data: {
    organization_id: string,
    urls: string[],
    base_url: string
}) => {
    return AxiosInstance.post(`${Config.FALKON_AI_URL}/falkon-chat-ai/api/scrape-web-pages`, data);
};//send the urls that needs to be scraped and trained by falkon ai

const DeleteTrainedUrlsFromAi = (data: {
    organization_id: string,
    website_urls: string[]
}) => {
    return AxiosInstance.post(`${Config.FALKON_AI_URL}/falkon-chat-ai/api/delete-web-scrape-urls`, data);
};//delete the data trained by urls from falkon ai

const WebsiteToCrawlandgetAllowedLinks = (data: {
    organization_id: string,
    website_url: string
}) => {
    return AxiosInstance.post(`${Config.FALKON_AI_URL}/falkon-chat-ai/api/get-allowed-links`, data);
};//get all the allowed links to scrape by crawling given website

const getAllUrls = (OrganizationID: string) => {
    return AxiosInstance.get(`${Config.FALKON_AI_URL}/falkon-chat-ai/api/get-web-page-links-details/${OrganizationID}`);
};//get all the urls sent for training to falkon ai

const TrainChatHistoryToAi = () => {
    return AxiosInstance.get(`${Config.API_URL}/api/Messages/PostChatParagraph`);
};//train chat history of the organisation to falkon ai

const DeleteChatHistoryFromAi = (data: {
    organization_id: string
}) => {
    return AxiosInstance.post(`${Config.FALKON_AI_URL}/falkon-chat-ai/api/delete-chat-history`, data);
};//delete the trained chat history from falkon ai

const getChatHistoryDetails = (OrganizationID: string) => {
    return AxiosInstance.get(`${Config.FALKON_AI_URL}/falkon-chat-ai/api/get-chat-history-details/${OrganizationID}`);
};//get chat history details trained to falkon ai

const updateSuggestedRepliesAcceptancy = (data: { suggestion_id: string, user_acceptancy: boolean }) => {
    return AxiosInstance.post(`${Config.FALKON_AI_URL}/falkon-chat-ai/api/update-user-acceptance`, data);
};//get update suggestion acceptancy

const getAcceptancyRateDetails = () => {
    return AxiosInstance.get(`${Config.FALKON_AI_URL}/falkon-chat-ai/api/suggested-reply-stats`);
};//get suggestion replies analytics in system admin



export const FalkonAiService = {
    getImprovedMessage,
    getChatSummaryandSentiment,
    getLastGeneratedChatSummaryandSentimentByPhoneNumber,
    getReplySuggestions,
    UploadFilesToAi,
    TrainUploadFilesToAi,
    TrainFailedFileToAi,
    DeleteTrainedFileFromAi,
    getAllFiles,
    TrainUrlsToAi,
    WebsiteToCrawlandgetAllowedLinks,
    getAllUrls,
    DeleteTrainedUrlsFromAi,
    TrainChatHistoryToAi,
    DeleteChatHistoryFromAi,
    getChatHistoryDetails,
    updateSuggestedRepliesAcceptancy,
    getAcceptancyRateDetails
}